import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../../login/login.service';

@Component({
  selector: 'app-duplicate-email-address',
  templateUrl: './duplicate-email-address.component.html',
  styleUrls: [
    './duplicate-email-address.component.css',
    '../familiy-registration-shared-style.css'
  ]
})
export class DuplicateEmailAddressComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<DuplicateEmailAddressComponent>,
    private loginService: LoginService
  ) { }

  ngOnInit() {
  }

  modalInstanceCloseClick() {

    this.dialogRef.close('Close was clicked.');
    this.loginService.resetLanguage.emit(true);
  }
}
